export default __webpack_public_path__ + "static/media/check_circle_FILL0_wght400_GRAD200_opsz48.b4ddde7e.svg";